import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { ApiNameList } from '../../../../environments/api-name-list';
import { HttpClientService } from '../../services/http-client-service';

@Injectable()
export class SaeForgotPasswordService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    forgotPass(requestObject) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.detailsUpdate, requestObject);
    }
    
   getSaeUserId(emailAddress:string) {
     let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('sae-portal', 'student');
        let body ={ email : emailAddress, action: 'forgotPassword' };
     return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getUserId, body, headers);
  }
 
  getOktaMfaFactors(userID:string) {
     let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('sae-portal', 'student');
        let body ={
                 userId: userID,
                 portal: "student"
                 };
     return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getOktaMfaFactors, body, headers);
  }
  getOktaMfaSendOtp(factorId:string, userID:string) {
     let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('sae-portal', 'student');
       let body ={
                 userId: userID,
                 factorId: factorId,
                 portal: "student"
                 };
     return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getOktaMfaSendOtp, body, headers);
  }
  getOktaMfaVerifyOtp(Otp:string, userID:string, factorId:string) {
     let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('sae-portal', 'student');
        let body ={
                 userId: userID,
                 factorId: factorId,
                 passCode: Otp,
                 portal: "student"
                 };
     return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getOktaMfaVerifyOtp, body, headers);
  }

}